var countryFullnameWithIso = {
  Canada: 'CA',
  'Sao Tome and Principe': 'ST',
  'Venezuela, Bolivarian Republic of': 'VE',
  'Guinea-Bissau': 'GW',
  Montenegro: 'ME',
  Lithuania: 'LT',
  Cambodia: 'KH',
  'Saint Helena, Ascension and Tristan da Cunha': 'SH',
  Switzerland: 'CH',
  Ethiopia: 'ET',
  Aruba: 'AW',
  'Saint Martin (French part)': 'MF',
  Argentina: 'AR',
  Cameroon: 'CM',
  'Burkina Faso': 'BF',
  Turkmenistan: 'TM',
  Ghana: 'GH',
  'Saudi Arabia': 'SA',
  Rwanda: 'RW',
  Togo: 'TG',
  Japan: 'JP',
  'American Samoa': 'AS',
  Montserrat: 'MS',
  'United States Minor Outlying Islands': 'UM',
  'Cocos (Keeling) Islands': 'CC',
  Pitcairn: 'PN',
  Guatemala: 'GT',
  'Bosnia and Herzegovina': 'BA',
  Kuwait: 'KW',
  'Russian Federation': 'RU',
  Jordan: 'JO',
  'Bonaire, Sint Eustatius and Saba': 'BQ',
  'Virgin Islands, British': 'VG',
  Dominica: 'DM',
  Liberia: 'LR',
  'Korea, Republic of': 'KR',
  'Micronesia, Federated States of': 'FM',
  Jamaica: 'JM',
  Oman: 'OM',
  Martinique: 'MQ',
  'Christmas Island': 'CX',
  'French Guiana': 'GF',
  Niue: 'NU',
  Monaco: 'MC',
  'Wallis and Futuna': 'WF',
  'New Zealand': 'NZ',
  'Virgin Islands, U.S.': 'VI',
  Jersey: 'JE',
  Andorra: 'AD',
  Yemen: 'YE',
  Albania: 'AL',
  Samoa: 'WS',
  'Norfolk Island': 'NF',
  'United Arab Emirates': 'AE',
  Guam: 'GU',
  India: 'IN',
  Azerbaijan: 'AZ',
  Lesotho: 'LS',
  'Saint Vincent and the Grenadines': 'VC',
  Kenya: 'KE',
  Macao: 'MO',
  Turkey: 'TR',
  Afghanistan: 'AF',
  Bangladesh: 'BD',
  Mauritania: 'MR',
  'Solomon Islands': 'SB',
  'Turks and Caicos Islands': 'TC',
  'Saint Lucia': 'LC',
  'San Marino': 'SM',
  'French Polynesia': 'PF',
  France: 'FR',
  'Syrian Arab Republic': 'SY',
  Bermuda: 'BM',
  Slovakia: 'SK',
  Somalia: 'SO',
  Peru: 'PE',
  Swaziland: 'SZ',
  Nauru: 'NR',
  Seychelles: 'SC',
  Norway: 'NO',
  Malawi: 'MW',
  'Cook Islands': 'CK',
  Benin: 'BJ',
  'Western Sahara': 'EH',
  Cuba: 'CU',
  'Iran, Islamic Republic of': 'IR',
  'Falkland Islands (Malvinas)': 'FK',
  Mayotte: 'YT',
  'Heard Island and McDonald Islands': 'HM',
  China: 'CN',
  Armenia: 'AM',
  'Timor-Leste': 'TL',
  'Dominican Republic': 'DO',
  Ukraine: 'UA',
  Bahrain: 'BH',
  Tonga: 'TO',
  Finland: 'FI',
  Libya: 'LY',
  'Cayman Islands': 'KY',
  'Central African Republic': 'CF',
  'New Caledonia': 'NC',
  Mauritius: 'MU',
  Tajikistan: 'TJ',
  Liechtenstein: 'LI',
  Australia: 'AU',
  Mali: 'ML',
  Sweden: 'SE',
  Bulgaria: 'BG',
  'Palestine, State of': 'PS',
  'United States': 'US',
  Romania: 'RO',
  Angola: 'AO',
  'French Southern Territories': 'TF',
  Chad: 'TD',
  'South Africa': 'ZA',
  Tokelau: 'TK',
  Cyprus: 'CY',
  'South Georgia and the South Sandwich Islands': 'GS',
  'Brunei Darussalam': 'BN',
  Qatar: 'QA',
  Malaysia: 'MY',
  Austria: 'AT',
  Mozambique: 'MZ',
  Slovenia: 'SI',
  Uganda: 'UG',
  Hungary: 'HU',
  Niger: 'NE',
  'Isle of Man': 'IM',
  Brazil: 'BR',
  Netherlands: 'NL',
  'Faroe Islands': 'FO',
  Guinea: 'GN',
  Panama: 'PA',
  Guyana: 'GY',
  'Costa Rica': 'CR',
  Luxembourg: 'LU',
  'Cape Verde': 'CV',
  Bahamas: 'BS',
  Gibraltar: 'GI',
  Ireland: 'IE',
  Pakistan: 'PK',
  Palau: 'PW',
  Nigeria: 'NG',
  Ecuador: 'EC',
  'Czech Republic': 'CZ',
  'Macedonia, Republic of': 'MK',
  'Viet Nam': 'VN',
  Belarus: 'BY',
  Vanuatu: 'VU',
  Algeria: 'DZ',
  "Korea, Democratic People's Republic of": 'KP',
  'El Salvador': 'SV',
  Tuvalu: 'TV',
  'Saint Pierre and Miquelon': 'PM',
  'Marshall Islands': 'MH',
  Chile: 'CL',
  'Puerto Rico': 'PR',
  Belgium: 'BE',
  Kiribati: 'KI',
  Haiti: 'HT',
  Belize: 'BZ',
  'Hong Kong': 'HK',
  'Sierra Leone': 'SL',
  Georgia: 'GE',
  "Lao People's Democratic Republic": 'LA',
  Gambia: 'GM',
  Philippines: 'PH',
  Morocco: 'MA',
  Croatia: 'HR',
  Mongolia: 'MN',
  Guernsey: 'GG',
  Thailand: 'TH',
  Namibia: 'NA',
  Grenada: 'GD',
  'Taiwan, Province of China': 'TW',
  '\u00c5land Islands': 'AX',
  Iraq: 'IQ',
  'Tanzania, United Republic of': 'TZ',
  Portugal: 'PT',
  Estonia: 'EE',
  Uruguay: 'UY',
  'Equatorial Guinea': 'GQ',
  Lebanon: 'LB',
  'Svalbard and Jan Mayen': 'SJ',
  Uzbekistan: 'UZ',
  Tunisia: 'TN',
  Djibouti: 'DJ',
  Greenland: 'GL',
  'Antigua and Barbuda': 'AG',
  Spain: 'ES',
  Colombia: 'CO',
  Burundi: 'BI',
  Fiji: 'FJ',
  Barbados: 'BB',
  Madagascar: 'MG',
  Italy: 'IT',
  Bhutan: 'BT',
  Sudan: 'SD',
  'Bolivia, Plurinational State of': 'BO',
  Nepal: 'NP',
  Malta: 'MT',
  Maldives: 'MV',
  'Northern Mariana Islands': 'MP',
  Suriname: 'SR',
  Anguilla: 'AI',
  Israel: 'IL',
  Réunion: 'RE',
  Indonesia: 'ID',
  Iceland: 'IS',
  Zambia: 'ZM',
  Senegal: 'SN',
  'Papua New Guinea': 'PG',
  'Saint Kitts and Nevis': 'KN',
  'Trinidad and Tobago': 'TT',
  Zimbabwe: 'ZW',
  Germany: 'DE',
  Denmark: 'DK',
  Kazakhstan: 'KZ',
  Poland: 'PL',
  'Moldova, Republic of': 'MD',
  Eritrea: 'ER',
  Kyrgyzstan: 'KG',
  'Congo, The Democratic Republic of the': 'CD',
  'Saint Barth\u00e9lemy': 'BL',
  'British Indian Ocean Territory': 'IO',
  'Holy See (Vatican City State)': 'VA',
  Mexico: 'MX',
  'Sri Lanka': 'LK',
  Latvia: 'LV',
  'South Sudan': 'SS',
  Curaçao: 'CW',
  Guadeloupe: 'GP',
  "C\u00f4te d'Ivoire": 'CI',
  Honduras: 'HN',
  Myanmar: 'MM',
  'Bouvet Island': 'BV',
  Egypt: 'EG',
  Nicaragua: 'NI',
  Singapore: 'SG',
  Serbia: 'RS',
  Botswana: 'BW',
  'United Kingdom': 'GB',
  Antarctica: 'AQ',
  Congo: 'CG',
  'Sint Maarten (Dutch part)': 'SX',
  Greece: 'GR',
  Paraguay: 'PY',
  Gabon: 'GA',
  Comoros: 'KM',
};

export default countryFullnameWithIso;
